export default class DefaultTinyMceConfig {
    // ReSharper disable InconsistentNaming
    // ReSharper disable IdentifierTypo
    plugins =
        "paste print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern help autoresize";
    paste_data_images = true;
    powerpaste_word_import = "clean";
    powerpaste_html_import = "merge";
    browser_spellcheck = true;
    toolbar =
        "formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | codesample | removeformat";
    contextmenu = false;

    height = 200;
    // the min/max height for the autoresize plugin - https://www.tiny.cloud/docs/plugins/autoresize/
    min_height = 200;
    max_height = 600;
    // ReSharper restore InconsistentNaming
    // ReSharper restore IdentifierTypo
}
